<template>
  <div class="layout">
    <div class="layout-sider layout-sider-light" style="height:100vh;z-index: 1000;" v-show="menuShow">
      <div class="logo">
        <h1>海逊ERP</h1>
      </div>
      <el-scrollbar wrap-class="scrollbar-wrapper" style="height:calc(100% - 64px)" :key="navListKey">
        <el-menu :collapse-transition="false" unique-opened router>
          <template v-for="item in this.arr">
            <el-submenu v-if="item.child && item.child.length" :index="item.id" :key="item.id">
              <!-- 左边一级tab栏 -->
              <!-- 8月5日 新增了一个图标 产品中心,
              不知道v-if includes 是做什么的权限判断,
              增加了 id 为196 逻辑到下面,用于显示class = iconfont 的自定义项 -->
              <!-- 4.16 新增了一个图标 产品库, 增加 id 为217 逻辑到下面,用于显示class = iconfont 的自定义项 具体css在public/index.html 引入的iconfont.css -->
              <template slot="title">
                <el-row type="flex" align="middle">
                  <el-row type="flex" align="middle">
                    <i v-if="['186', '189','196','197'].includes(item.id)" class="iconfont"
                      :class="iconList[item.jurisdictionName]" style="color:#fff;margin-right:0.48vw;"></i>
                    <i v-else class="element-icons" :class="iconList[item.jurisdictionName]"
                      style="color:#fff;margin-right:0.48vw;"></i>
                    {{ item.jurisdictionChineseName }}
                  </el-row>
                </el-row>
              </template>
              <!-- 二级菜单 -->
              <template v-for="itemChild in item.child">
                <el-submenu v-if="itemChild.child && itemChild.child.length" :index="itemChild.id" :key="itemChild.id">
                  <template slot="title">
                    <span>{{ itemChild.jurisdictionChineseName }}</span>
                  </template>
                  <!-- 三级菜单 -->
                  <el-menu-item v-for="itemChild_Child in itemChild.child" @click="Level3(itemChild_Child)"
                    :key="itemChild_Child.id">
                    <span slot="title">{{ itemChild_Child.jurisdictionChineseName }}</span>
                  </el-menu-item>
                </el-submenu>
                <el-menu-item v-else @click="Level2(itemChild)">
                  <span slot="title">{{ itemChild.jurisdictionChineseName }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item v-else @click="Home(item)">
              <template slot="title">
                <el-row type="flex" align="middle">
                  <i v-if="['234'].includes(item.id)" class="iconfont2"
                    :class="iconList[item.jurisdictionName]" style="color:#fff;margin-right:0.48vw;"></i>
                  <i v-else-if="['196','197', '217'].includes(item.id)" class="iconfont"
                    :class="iconList[item.jurisdictionName]" style="color:#fff;margin-right:0.48vw;"></i>
                  <i v-else class="element-icons" :class="iconList[item.jurisdictionName]"
                    style="color:#fff;margin-right:0.48vw;"></i>
                  {{ item.jurisdictionChineseName }}
                </el-row>
              </template>
            </el-menu-item>
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
    <!-- 选择角色select列表 -->
    <section class="layout-section">
      <header class="layout-header" v-show="menuShow">
        <div class="left-box">
          <div class="layout-left">
            <el-select @change="selectChanged" v-model="value" placeholder="请选择" @visible-change="visibleChange">
              <el-option v-for="item in obj.data.roles" :key="item.rid" :label="item.roleUserName"
                :value="item.rid"></el-option>
            </el-select>
          </div>
          <div class="layout-left cleft" style="color:#fff">
            <img class="layout-imga" src="../assets/imags/Chine.png" alt />
            北京：{{ nowTime }}
          </div>
          <div class="layout-left cleft" style="color:#fff">
            <img class="layout-imga" src="../assets/imags/Europe.png" alt />
            美东：{{ mdTime }}
          </div>
          <div class="layout-left cleft" style="color:#fff">
            <img class="layout-imga" src="../assets/imags/Europe.png" alt />
            美西：{{ mxTime }}
          </div>
          <div class="layout-left cleft" style="color:#fff">
            <img class="layout-imga" src="../assets/imags/USA.png" alt />
            欧洲：{{ ozTime }}
          </div>
          <div class="layout-left cleft" style="color:#fff">
            <img class="layout-imga" src="../assets/imags/Japon.png" alt />
            日本：{{ rbTime }}
          </div>
        </div>
        <div class="right-box">
          <currency-converter />
          <div class="header-right">
            <el-button @click="gotoProjectManagement" v-if="projectManagementRule || projectTelphoneList.includes(userTelphone)">项目管理</el-button>
            <el-button @click="gotoImageTranslationEditor" v-if="permissions">图片翻译编辑器</el-button>
          </div>
          <div class="header-right icon">
            <el-tooltip effect="dark" content="常见问题" placement="bottom">
              <i class="el-icon-question header_i" @click="drawer = true" />
            </el-tooltip>
          </div>
          <div class="header-right icon" @click="repairOrder" v-if="isShowRepair">
            <img src="../assets/imags/工单.png" alt />
          </div>
          <div class="header-right icon">
            <el-dropdown @command="toPage" placement="bottom">
              <el-badge is-dot :hidden="numberOfUnreadPlatformAnnouncements<=0 && numberOfUnreadPlatformNews<=0">
                <i class="el-icon-bell header_i"></i>
              </el-badge>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="news">
                  <el-row type="flex" justify="space-between" align="middle" style="width:5.76vw;">
                    <div>平台消息</div>
                    <div class="header-right-tips" v-if="numberOfUnreadPlatformNews>0">{{ numberOfUnreadPlatformNews }}
                    </div>
                  </el-row>
                </el-dropdown-item>
                <el-dropdown-item command="notice">
                  <el-row type="flex" justify="space-between" align="middle" style="width:5.76vw;">
                    <div>平台公告</div>
                    <div class="header-right-tips" v-if="numberOfUnreadPlatformAnnouncements>0">{{
                      numberOfUnreadPlatformAnnouncements }}
                    </div>
                  </el-row>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="header-right">
            <el-dropdown @command="basicRevisiont" placement="bottom">
              <span class="header-right-icon">
                <span class="header-avatar">
                  <img v-if="this.headPortrait == null"
                    src="https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png" alt />
                  <img v-if="this.headPortrait != null" :src="this.headPortrait" alt />
                </span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="BuyBox">安全退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>


      </header>
      <div>
        <el-row type="flex" justify="space-between" style="overflow: hidden;width:90.2vw" v-show="menuShow">
          <el-tabs type="card" v-model="editableTabsValue" @tab-remove="removeTab" @tab-click="tabclick"
            style="flex:1;max-width:95%">
            <el-tab-pane v-for="item in routerList" :key="item.path" :name="item.path" :label="item.meta.title"
              :closable="item.meta.isClose ? false : true" @keyup.prevent></el-tab-pane>
          </el-tabs>
          <el-button type="text" style="border:none" @click="allTabClose">全部关闭</el-button>
        </el-row>

        <div class="layout-content" :style="menuShow?'width:88vw':'width:100vw'">
          <keep-alive :include="[
            $store.state.user.isCache ? 'EstablishProduct' : '',
            $store.state.user.isCacheConmmodity ? 'ConmmoditySummary' : ''
          ]">
            <router-view :key="editableTabsValue" :roleStatus="roleStatus"></router-view>
          </keep-alive>
          <el-drawer title="常见问题" :visible.sync="drawer" :with-header="false">
            <div style="padding: 0.96vw;height: 100%;">
              <el-row style="margin-bottom: 0.96vw;">
                <el-input placeholder="请输入要搜索的内容" v-model="drawerKeyWord" @input="handleDrawerInput" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="handleDrawerButton"></el-button>
                </el-input>
              </el-row>
              <!-- <template v-else>-->
              <template v-if="listDrawerQuestion.length">
                <template v-for="(key) in listDrawerQuestion">
                  <div class="question-query" @click="openDialogAnswer(key)">
                    <div class="question-query-title" v-html="key.errorType"></div>
                    <div class="question-query-discription" v-html="key.briefIntroduction"></div>
                  </div>
                </template>
              </template>
              <template v-else-if="!listDrawerQuestion.length && isDrawerNotQuery">
                <div style="text-align: center;color: #aaa;">没有搜索到内容</div>
              </template>
              <template v-else>
                <el-collapse class="cus-collapse" accordion v-loading="loadingCollapse" @change="handleCollapse"
                  style="height: calc(100% - 30px);">
                  <template v-for="item in listParents">
                    <el-collapse-item :title="item.errorType" :name="item.id">
                      <div v-for="(key) in item.children" :key="key.id" style="width: 100%;margin-top: 0.48vw;">
                        <el-link style="width: 100%;justify-content: flex-start" :underline="false"
                          @click="openDialogAnswer(key)">
                          <span>{{ `${ key.errorType }` }}</span>
                        </el-link>
                      </div>
                    </el-collapse-item>
                  </template>
                </el-collapse>
              </template>
              <!--              </template>-->
            </div>
          </el-drawer>
          <el-dialog :title="dialogData.errorType" :visible.sync="dialogVisible" width="48vw" top="4vh">
            <div slot="title" v-html="dialogData.errorType"></div>
            <div class="custom-dialog" v-html="dialogData.answer"></div>
          </el-dialog>
          <el-dialog :title="dialogData.errorType" :visible.sync="dialogVisible" width="48vw" top="4vh">
            <div slot="title" v-html="dialogData.errorType"></div>
            <div class="custom-dialog" v-html="dialogData.answer"></div>
          </el-dialog>
        </div>
      </div>
      <footer class="layout-footer"></footer>
    </section>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import { ajaxGet, ajaxPost, Baseurl } from "../api/api/api";
  import { isUS_Dst } from '../utils/timeZone'
  import { VerifyPermissions } from '../utils/auxiliary'
  import loadDify from '../utils/dify'
  import CurrencyConverter from '../components/CurrencyConverter/index.vue'
  // 判断美国现在是否夏令时，true 为是
  let isDst = isUS_Dst()

  let drawerInputTimer = null

  export default {
    name: "layout",
    ...mapState(["setuser", "buttonShow"]),
    data() {
      return {
        isPageRefreshed: false,
        isDst: isDst,
        str: "",
        levelList: {},
        value: "",
        nowTime: "",
        mdTime: "",
        mxTime: "",
        ozTime: "",
        rbTime: "",
        user: "",
        editableTabsValue: "",
        screenWidth: "",
        obj: "",
        arr: [],
        arr1: "",
        headPortrait: "",
        navListKey: "",
        prevUserValue: "",
        iconList: {
          AllegroProduct: "icon-ALLEGRO",
          WalmartProduct: "icon-guanggao",
          BaseProduct: "icon-chanpinzhongxin",
          ozonProduct: "icon-Ozon",
          Thome: "hx-shouye",
          UserManage:"hx-yonghuguanli",
          BusinessManage:"hx-shangwuguanli",
          ServiceManage:"hx-fuwu",
          addInformation: "hx-gonggaofabu1",
          OverallSituation: "hx-gongsiguanli",
          analysis: "hx-gongsizhuye",
          productsToBeReleased: "hx-shangpinguanli",
          AdvertisingArbitrage:"icon-guanggao",
          amazonProducts: "hx-yamaxun",
          FBMorder: "hx-dingdanguanli-active",
          FBAorder: "hx-dingdan1",
          Taboola: "hx-dingdan1",
          orderBoard: 'hx-dingdanguanli-active',
          financialManagement: "hx-caiwuguanli",
          privilegeManagement: "hx-quanxian",
          ProcurementManagement: "hx-caigouguanli1",
          inventoryManagement: "hx-kucunguanli",
          UserCenter: "hx-yonghuzhongxin",
          HaysonMall: "hx-haixunshangcheng",
          "System maintenance": "hx-xitongyunwei",
          Logisticsmanagement: "hx-wuliuguanli",
          generalSettings: "hx-tongyongshezhi",
          Teachingvideo: 'hx-jiaoxueshipin',
          Tortvocabulary: 'hx-qin',
          Suggestionbox: 'hx-jianyi',
          // AmazonRushesToSell: 'hx-xitongyunwei',
          AmazonRushesToSell: 'hx-gangenmai',
          SkuManagement: 'hx-fenleiguanli',
          shopeeProduct: 'icon-shopee',
          AmazonProductLibrary: 'icon-P', //产品库
          CashbackRecords: "icon-fanxian", //返现记录
        },
        roleStatus: "",
        roleSystem: "",
        numberOfUnreadPlatformNews: 0,
        numberOfUnreadPlatformAnnouncements: 0,
        UserInfo: localStorage.getItem('role'),

        drawer: false,
        drawerKeyWord: '',
        loadingCollapse: false,
        listParents: [],
        dialogData: {},
        dialogVisible: false,
        listDrawerQuestion: [],
        isDrawerNotQuery: false,
        menuShow: true,
        projectManagementRule: false,
        projectTelphoneList: [],
        userTelphone: '',
        permissions: false,
      };
    },
    beforeCreate() {
      this.isPageRefreshed = false; // 或者其他初始化逻辑
    },
    components: {
      CurrencyConverter,
    },
    watch: {
        $route(){
            this.getBreadcrumb();
            const param = {
                meta: this.$route.meta,
                name: this.$route.fullPath,
                path: this.$route.fullPath,
            };
            this.$store.dispatch("setCrumbList", param);
            this.editableTabsValue = this.$route.path;
        },
    },
    async created() {
      if (!this.isPageRefreshed) { // 如果页面之前未被标记为已加载，则认为是刷新或首次加载
        this.isPageRefreshed = true; // 标记为已加载，防止再次触发
        this.$store.state.user.isSave = false;
      }
      this.user = JSON.parse(window.localStorage.getItem("user"));
      this.getBreadcrumb();
      var clientWidth = document.body.clientWidth;
      this.screenWidth = clientWidth - 250 + "px";

      // this.headPortrait = this.user.headPortrait;
      this.obj = JSON.parse(localStorage.getItem("data"));
      this.userTelphone = this.obj.data.user.telephone;
      this.headPortrait = this.obj.data.user.headPortrait;
      this.getListParent()
      if (this.$route.query.menuHide) {
        this.menuShow = false
      } else {
        this.menuShow = true
      }
      this.getProjectManagementRule(); //获取项目管理权限
      this.getProjecTelphone(); //获取能操作项目管理的手机号列表
      await this.VerifyPermissions();
    },
    mounted() {
      this.nowTimes();
      this.remotevalue();
      this.selectChanged();
      const user1 = this.obj.data.user;
      // 是否显示知识库
      const arr = (user1.aiPower + "").split(',');
      if(arr.includes('1')){
        loadDify('6deVXFmVxAYoMoiY') // 亚马逊 dify token
      }
      this.getPermissions();
    },
    // beforeMount: function () {
    //   this.value = this.obj.data.roles[0].roleUserName;
    // },
    computed: {
      routerList() {
        return this.$store.state.user.crumbList;
      },
      RouterViewKey() {
        return this.$route.name + new Date();
      },
      isShowRepair() {
        const UserInfo = JSON.parse(localStorage.getItem('role'))
        if (!UserInfo || !Object.keys(UserInfo).length) return false
        const DepartmentResult = UserInfo.superDepartmentName === '运营部' || UserInfo.superDepartmentName === '客服部' || UserInfo.superDepartmentName === '仓库客服部' || UserInfo.superDepartmentName === '采购部';
        return (UserInfo.system === 5 && DepartmentResult) || (UserInfo.superDepartmentName === '常规客服部' && UserInfo.type === 1)
      },
    },
    methods: {
      loadDify,
      async getPermissions(){
          const telephone = this.obj.data.user.telephone;
          const API = Baseurl + 'aidgeController/verifyPermissions'
          const res = await ajaxPost(API, {telephone});
          this.permissions = res.data.data;
      },
      getProjectManagementRule(){
        const params = {
          uid: this.obj.data.user.uid,
        }
        ajaxPost(Baseurl + 'projectController/selectUserProjectJurisdiction', params).then((res)=>{
          if(res.data.code === 200){
            this.projectManagementRule = res.data.data;
            localStorage.setItem("projectManagementRule", this.projectManagementRule);
          }
        })
      },
      getProjecTelphone(){
        ajaxGet(Baseurl + 'projectController/selectProjectJurisdictionUserList').then((res)=>{
          if (res.data.code === 200) {
            this.projectTelphoneList = res.data.data;
            localStorage.setItem("projectTelphoneList", JSON.stringify(this.projectTelphoneList));
          }
        })
      },
      gotoProjectManagement(){
        window.open('/#/projectManagement', '_blank'); // '_blank' 表示新标签页
      },
      gotoImageTranslationEditor(){
        window.open('/#/ImageTranslationEditor', '_blank'); // '_blank' 表示新标签页
      },
        VerifyPermissions,
      Home(item) {
        this.$router.push({
          path: "/box" + "/" + item.jurisdictionName,
        });
      },
      Level2(itemChild) {
        this.$router.push({
          path: "/box" + "/" + itemChild.jurisdictionName,
        });
      },
      Level3(itemChild_Child) {
        this.$router.push({
          path: "/box" + "/" + itemChild_Child.jurisdictionName,
        });
      },
      getBreadcrumb() {
        let matched = this.$route.matched.filter((item) => item.meta.title);
        const first = matched[0];
        if (first && first.name !== "dashboard") {
          matched = [{ path: "/dashboard", meta: { title: "首页" } }].concat(
                  matched,
          );
        }
        this.levelList = matched;
      },
      remotevalue() {
        this.value = this.obj.data.roles[0].rid;
      },
      getTree(arr, pid = 0) {
        if (!Array.isArray(arr) && !arr.length) return;
        const resultArr = [];
        arr.forEach((item) => {
          if (item.pid === pid) {
            const itemObj = {
              ...item,
              id: item.id + "",
              child: this.getTree(arr, item.id),
            };
            resultArr.push(itemObj);
          }
        });
        return resultArr.sort((a, b) => a.order - b.order);
      },
      visibleChange(event) {
        if (event) this.prevUserValue = this.value;
      },
      selectChanged(val) {
        const handleRequest = () => {
          var url = Baseurl + "roleController/selectRoleJurisdiction";
          var val = {
            rid: this.value,
          };
          this.$http.post(url, val).then((res) => {
            const { code, data } = res.data;
            if (code === 200) {
              this.UserInfo = data.role
              const navList = this.getTree(data.jurisdiction, 0);
              this.arr = navList;
              window.localStorage.setItem("role", JSON.stringify(data.role));
              this.$store.commit("setRole", data.role);
              this.$store.commit("clearCrumbList");
              // console.log(this.editableTabsValue)
              // const itemJson =  data.jurisdiction.find((item) => { return '/box/' + item.jurisdictionName === this.editableTabsValue })
              // console.log(itemJson)
              // if(!itemJson) {
              var str = window.location.href;
              if(!this.menuShow) {
                const obj = {
                  meta: { title: "SKU管理" },
                  name: "/box/SkuManagement",
                  path: "/box/SkuManagement",
                }
                this.routerList.push(obj)
                this.editableTabsValue = "/box/SkuManagement";
              } else {
                //刷新页面时不回首页
                // var url = str.substring(23,str.length);
                if(str.indexOf("/box/CommissionSettlementDetails") !== -1){
                  const targetObj = this.hasJurisdiction(navList, this.$route.name);
                  if(targetObj){
                    this.$router.push({
                      path: this.$route.path,
                    });
                    this.editableTabsValue = this.$route.path;
                    const obj = {
                      meta: { title: targetObj.jurisdictionChineseName },
                      name: this.$route.path,
                      path: this.$route.path,
                    }
                    this.routerList.push(obj)
                  }else{
                    this.$router.push({
                      path: "/box/Thome",
                    });
                    this.editableTabsValue = "/box/Thome";
                  }
                }else if(str.indexOf("/box/Thome") !== -1 || data.role.type != 3 || data.role.system != 1 ) {
                  this.$router.push({
                    path: "/box/Thome",
                  });
                  this.editableTabsValue = "/box/Thome";
                }else if(str.indexOf("/box/ShopifyLicensing") !== -1 && data.role.type == 3 && data.role.system == 1){
                  const obj = {
                    meta: { title: " shopify授权" },
                    name: "/box/ShopifyLicensing",
                    path: "/box/ShopifyLicensing",
                  }
                  this.routerList.push(obj)
                  this.editableTabsValue = "/box/ShopifyLicensing";
                }else if(str.indexOf("/box/ShoplazzaAuthorize") !== -1 && data.role.type == 3 && data.role.system == 1){
                  const obj = {
                    meta: { title: " shoplazza授权" },
                    name: "/box/ShoplazzaAuthorize",
                    path: "/box/ShoplazzaAuthorize",
                  }
                  this.routerList.push(obj)
                  this.editableTabsValue = "/box/ShoplazzaAuthorize";
                }else if(str.indexOf("/box/ShopeeAuthorize") !== -1 && data.role.type == 3 && data.role.system == 1){
                  const obj = {
                    meta: { title: " Shoppee授权" },
                    name: "/box/ShopeeAuthorize",
                    path: "/box/ShopeeAuthorize",
                  }
                  this.routerList.push(obj)
                  this.editableTabsValue = "/box/ShopeeAuthorize";
                }else if(str.indexOf("/box/ShoplineAuthorize") !== -1 && data.role.type == 3 && data.role.system == 1){
                  const obj = {
                    meta: { title: " shopline授权" },
                    name: "/box/ShoplineAuthorize",
                    path: "/box/ShoplineAuthorize",
                  }
                  this.routerList.push(obj)
                  this.editableTabsValue = "/box/ShoplineAuthorize";
                }else if(str.indexOf("/box/PayPalAuthorize") !== -1 && data.role.type == 3 && data.role.system == 1){
                  const obj = {
                    meta: { title: " PayPal授权" },
                    name: "/box/PayPalAuthorize",
                    path: "/box/PayPalAuthorize",
                  }
                  this.routerList.push(obj)
                  this.editableTabsValue = "/box/PayPalAuthorize";
                }else if(str.indexOf("/box/TikTokAuthorize") !== -1 && data.role.type == 3 && data.role.system == 1){
                  const obj = {
                    meta: { title: " TikTok授权" },
                    name: "/box/TikTokAuthorize",
                    path: "/box/TikTokAuthorize",
                  }
                  this.routerList.push(obj)
                  this.editableTabsValue = "/box/TikTokAuthorize";
                }else if(str.indexOf("/box/AllegroAuthorize") !== -1 && data.role.type == 3 && data.role.system == 1){
                  const obj = {
                    meta: { title: " Allegro授权" },
                    name: "/box/AllegroAuthorize",
                    path: "/box/AllegroAuthorize",
                  }
                  this.routerList.push(obj)
                  this.editableTabsValue = "/box/AllegroAuthorize";
                }else if(str.indexOf("/box/AliexpressAuthorize") !== -1 && data.role.type == 3 && data.role.system == 1){
                  const obj = {
                    meta: { title: " Aliexpress授权" },
                    name: "/box/AliexpressAuthorize",
                    path: "/box/AliexpressAuthorize",
                  }
                  this.routerList.push(obj)
                  this.editableTabsValue = "/box/AliexpressAuthorize";
                }else{
                  this.$router.push({
                    path: "/box/Thome",
                  });
                  this.editableTabsValue = "/box/Thome";
                }
              }
              this.roleStatus = data.role.rid;
              this.roleSystem = data.role.system
              this.getUnreadMsgNum()
              this.successlogin()
            }
          });
          this.navListKey = val.rid;
        };
        const flag = this.$store.state.user.isSave;
        if (flag && !this.isPageRefreshed) {
          this.$confirm("您确定要退出此页面?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
                  .then(() => {
                    this.$store.state.user.isSave = false;
                    handleRequest();
                  })
                  .catch(() => {
                    handleRequest();
                  });
        } else {
          handleRequest();
        }
      },
      hasJurisdiction(data, targetName) {
        for (const item of data) {
          if (item.jurisdictionName === targetName) {
            return item;
          }
          if (item.child && item.child.length > 0) {
            if (this.hasJurisdiction(item.child, targetName)) {
              return item;
            }
          }
        }
        return null;
      },
      successlogin() {
        var str = JSON.parse(localStorage.getItem("role"));
        var url = Baseurl + "orderController/getOrdersellerInfoByRoleId";
        var val = {
          rid: str.rid,
          system: str.system,
        };
        this.$http.post(url, val).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            window.localStorage.setItem("sellerInfo", JSON.stringify(res.data.data));
          }
        });
      },
      timeFormate(timeStamp) {
        const timeDate = new Date(timeStamp);
        const [month, date, hh, mm, ss] = [
          timeDate.getMonth() + 1 < 10
                  ? "0" + (timeDate.getMonth() + 1)
                  : timeDate.getMonth() + 1,
          timeDate.getDate() < 10 ? "0" + timeDate.getDate() : timeDate.getDate(),
          timeDate.getHours() < 10
                  ? "0" + timeDate.getHours()
                  : timeDate.getHours(),
          timeDate.getMinutes() < 10
                  ? "0" + timeDate.getMinutes()
                  : timeDate.getMinutes(),
          timeDate.getSeconds() < 10
                  ? "0" + timeDate.getSeconds()
                  : timeDate.getSeconds(),
        ];
        return month + "-" + date + " " + hh + ":" + mm + ":" + ss;
      },
      nowTimes() {
        this.nowTime = this.timeFormate(new Date()); // 北京时间
        let num1 = this.isDst ? 12 : 13
        let num2 = this.isDst ? 15 : 16
        this.mdTime = this.timeFormate(+new Date() - num1 * 3600000); // 美东
        this.mxTime = this.timeFormate(+new Date() - num2 * 3600000); // 美西
        this.ozTime = this.timeFormate(+new Date() - 7 * 3600000); // 欧洲
        this.rbTime = this.timeFormate(+new Date() + 1 * 3600000); // 日本
        setTimeout(() => {
          this.nowTimes();
        }, 1000);
      },
      basicRevisiont(command) {
        if (command === "modify") {
        } else if (command === "BuyBox") {
          this.$store.commit('loginOut');
          this.$router.push({ name: 'Login' });
          window.location.reload()
        }
      },
      removeTab(targetName) {
        const flag = this.$store.state.user.isSave;
        if ((targetName === "/box/createANEWproduct") || (targetName === '/box/CoupangCreateProduct') ||
                (targetName === '/box/ShopeeCreateProduct') && flag) {
          this.$confirm("您确定要退出此页面?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
                  .then(() => {
                    this.$store.state.user.isSave = false;
                    this.$store.state.user.isCache = false;
                    this.$store.dispatch("delCrumbList", targetName);
                    if (targetName == this.editableTabsValue) {
                      this.$router.push({
                        path: "/box/Thome",
                      });
                    }
                  })
                  .catch(() => {
                    this.editableTabsValue = "/box/createANEWproduct";
                  });
        } else {
          this.$store.dispatch("delCrumbList", targetName);
          if (targetName == this.editableTabsValue) {
            this.$router.push({
              path: "/box/Thome",
            });
          }
        }
      },
      tabclick(targetName) {
        const flag = this.$store.state.user.isSave;
        if (flag) {
          this.$confirm("您确定要退出此页面?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
                  .then(() => {
                    this.$store.state.user.isSave = false;
                    this.$router.push({
                      path: targetName.paneName,
                    });
                  })
                  .catch(() => {
                    this.editableTabsValue = "/box/createANEWproduct";
                  });
        } else {
          this.$router.push({
            path: targetName.paneName,
          });
        }
      },
      // 查看信息
      Seenews() {
        this.$router.push({
          path: "/dashboard/notice",
          query: {
            id: "1",
          },
        });
      },
      allTabClose() {
        const flag = this.$store.state.user.isSave;
        if (flag) {
          this.$confirm("您确定要退出此页面?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
                  .then(() => {
                    this.$store.state.user.isSave = false;
                    this.$store.state.user.isCache = false;
                    this.$store.commit("clearCrumbList");
                    this.$router.push({
                      path: "/box/Thome",
                    });
                    this.editableTabsValue = "/box/Thome";
                  })
                  .catch(() => {
                    this.editableTabsValue = "/box/createANEWproduct";
                  });
        } else {
          this.$store.commit("clearCrumbList");
          this.$router.push({
            path: "/box/Thome",
          });
          this.editableTabsValue = "/box/Thome";
        }
      },
      toPage(type) {
        this.$router.push({ name: "noticeList", params: { pageType: type } });
      },
      getUnreadMsgNum() {
        const API = Baseurl + 'roleController/selectNumberOfNews'
        const paramsData = { rid: this.roleStatus }
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            this.numberOfUnreadPlatformNews = data.numberOfUnreadPlatformNews;
            this.numberOfUnreadPlatformAnnouncements = data.numberOfUnreadPlatformAnnouncements;
          }
        })
      },
      repairOrder() {
        this.$router.push({
          path: "/box/repairOrder",
        })
      },

      getListParent() {
        const API = Baseurl + 'helpController/selectFather'
        this.loadingCollapse = true
        ajaxPost(API).then(res => {
          this.loadingCollapse = false
          const { code, data } = res.data
          if (code === 200) {
            data.forEach(item => {
              item.isHasChild = true
              item.children = []
            })
            this.listParents = data
          }
        })
      },
      handleCollapse(val) {
        if (!val) return
        const tempObj = this.listParents.find(item => item.id === val)
        //   if (!tempObj.isHasChild || tempObj.children.length) return
        this.getListTable(tempObj)
      },
      getListTable(item) {
        const API = Baseurl + 'helpController/selectByPid'
        const paramsData = {
          pid: item.id,
          type: '2',
        }
        this.loadingTable = true
        ajaxPost(API, paramsData).then(res => {
          this.loadingTable = false
          const { code, data } = res.data
          if (code === 200) {
            this.$set(item, 'children', data)
            if (!data.length) this.$set(item, 'isHasChild', false)
          }
        })
      },
      openDialogAnswer(item) {
        this.dialogData = item
        this.dialogVisible = true
      },
      handleDrawerInput() {
        if (!this.drawerKeyWord) {
          this.listDrawerQuestion = []
          this.isDrawerNotQuery = false
          clearTimeout(drawerInputTimer)
          return
        }
        if (drawerInputTimer) clearTimeout(drawerInputTimer)
        drawerInputTimer = setTimeout(() => {
          this.handleDrawerButton()
        }, 500)
      },
      handleDrawerButton() {
        const API = Baseurl + 'helpController/selectByKeyWord'
        const paramsData = {
          keyWord: this.drawerKeyWord,
          type: 2
        }
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            this.listDrawerQuestion = data
            if (!data.length) this.isDrawerNotQuery = true
          }
        })
      },
    },
  };
</script>

<style lang="scss">
  .layout {
    .el-badge__content.is-fixed {
      top: 20px;
    }

    .el-menu {
      background-color: #061f3e;
    }

    .el-submenu__title {
      color: #fff;
    }

    .el-menu-item {
      color: #fff;
    }

    .el-breadcrumb__inner {
      color: #fff;
    }

    .el-submenu__title:hover,
    .el-menu-item:focus,
    .el-menu-item:hover {
      background-color: #409eff;
    }

    .el-menu-item.is-active {
      color: #fff;
    }

    display: flex;
    flex-direction: row;

    .layout-sider {
      flex: 0 0 200px;
      max-width: 200px;
      min-width: 200px;
      width: 200px;
      background-color: #061f3e;

      .logo {
        height: 64px;
        line-height: 64px;
        background: #002140;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        h1 {
          color: #fff;
          font-size: 20px;
          font-family: Myriad Pro, Helvetica Neue, Arial, Helvetica, sans-serif;
        }
      }
    }

    .layout-section {
      min-height: 100vh;
      background: #fff;
      display: flex;
      position: relative;
      flex-direction: column;
      flex: auto;

      .layout-header {
        height: 64px;
        line-height: 64px;
        padding: 0px;
        background: #061f3e;
        width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left-box {
			display: flex;
			align-items: center;
		}
		.right-box {
			display: flex;
			align-items: center;
			height: 100%;
			box-sizing: border-box;
		}

        // .layout-left {
        //   float: left;
        // }

        .layout-imga {
			width: 18px;
			height: 12px;
        }

        .cleft {
			// width: 12%;
			display: flex;
			align-items: center;
			text-align: center;
			letter-spacing: 1px;
			padding: 0 25px;
			img{
				margin-right: 5px;
			}
        }

        .header-left {
			margin-left: 5px;
			line-height: 64px;
			color: #fff;
        }

        .header-right {
			position: relative;
			cursor: pointer;
			margin-left: 15px;
			&.icon{
				width: 20px;
				height: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.header-right-icon {
				padding: 0 12px;
				color: #fff;
				display: inline-block;
				transition: all 0.3s;
				height: 100%;

				&:hover {
					background: rgba(0, 0, 0, 0.025);
				}

				.header-avatar {
					margin: 20px 8px 20px 0;
					color: #1890ff;
					background: hsla(0, 0%, 100%, 0.85);
					vertical-align: top;
					width: 24px;
					height: 24px;
					line-height: 24px;
					border-radius: 50%;
					font-family: Chinese Quote, -apple-system, BlinkMacSystemFont,
					Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei,
					Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji,
					Segoe UI Emoji, Segoe UI Symbol;
					font-size: 14px;
					font-variant: tabular-nums;
					box-sizing: border-box;
					padding: 0;
					list-style: none;
					display: inline-block;
					text-align: center;
					white-space: nowrap;
					position: relative;
					overflow: hidden;

					& > img {
						width: 100%;
						height: 100%;
						display: block;
					}
				}
			}
        }

        .header_i {
          color: #fff;
          font-size: 20px;
        }
      }

      .layout-content {
        margin: 20px 0px 0px 24px;
        padding-top: 0px;
        flex: auto;
        min-height: 0;
        overflow: auto;
        height: calc(100vh - 125px);
      }

      .layout-footer {
        background: #f0f2f5;
        color: rgba(0, 0, 0, 0.65);
        padding: 0;
      }
    }

    .el-tabs__header {
      margin: 0px;
    }
  }

  .header-right-tips {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: red;
    color: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 16px;
  }
</style>
<style>
  .scrollbar-wrapper {
    overflow-x: hidden !important;
  }

  .custom-dialog img {
    max-width: 100%;
    margin: 10px 0;
    border: 1px solid rgba(0,0,0,.3);
  }

  .question-query {
    cursor: pointer;
    margin-bottom: 10px;
  }
  .question-query + .question-query  {
    border-top: 1px solid #ccc;
  }

  .question-query-title {
    font-weight: bolder;
    font-size: 18px;
    color: #68add5;
    margin-bottom: 5px;
  }

  .question-query-discription {
    color: #666666;
  }

  .question-query:hover .question-query-title,
  .question-query:hover .question-query-discription{
    color: #dd9c31;
  }

  .cus-collapse .el-collapse-item .el-collapse-item__header{
    font-weight: bolder;
  }
  .hx-jiaoxueshipin {
    font-size: 10px;
  }
</style>
